import { Component, OnDestroy } from '@angular/core';
import * as Rx from 'rxjs';
import { ApiRequestDto, NursingStation, SortFilterDto } from '../api';

/**
 * Base class for components that need some common functionality.
 */
@Component({
    template: '',
    host: {
        'class' : 'abstract-base'
      }    
  })
export abstract class AbstractBaseComponent implements OnDestroy {

    /** The stop stream emits when new parameters will be soon coming. Use to abort any in-progress requests. */
    protected stop$ = new Rx.Subject();
    /** A stream that emits when this component is being destroyed */
    protected destroy$ = new Rx.Subject();

    /**
     * Destroy component.
     */
    ngOnDestroy() {
        if(this.stop$){
            this.stop$.next(void 0);
            this.stop$.complete();
        }

        if(this.destroy$) {
            this.destroy$.next(void 0);
            this.destroy$.complete();
        }
    }

    protected packRequestObject(startDate?: Date, endDate?: Date, orgList?: Array<string>, sortFilterDto?: SortFilterDto, nursingStations?: Array<NursingStation>): ApiRequestDto {
        const requestObject: ApiRequestDto = {
            StartDate: startDate,
            EndDate: endDate,
            OrgList: orgList,
            SortsAndFilters: sortFilterDto,
            NursingStations: nursingStations
        };
        return requestObject;
    }
}
